import React, { useEffect, useState } from "react";
import { FcSearch } from "react-icons/fc";

import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import Button from "@material-ui/core/Button";
import JDate from "jalali-date";

import styles from "../../../styles/management.module.css";
import reducer from "../../store";
import { useNavigate } from "react-router";
import { AutoSizer, Column, Table } from "react-virtualized";

const Devices = () => {
    const history = useNavigate();

    const [search, set_search] = useState("");
    const [devices, set_devices] = useState(Object.values(reducer.getState().devices.items));

    useEffect(() => {
        if (search !== "")
            set_devices(
                Object.values(reducer.getState().devices.items).filter((x) => (x.phone && x.phone.includes(search)) || (x.name && x.name.includes(search)) || x.uniqueId.includes(search))
            );
        else set_devices(Object.values(reducer.getState().devices.items));
    }, [search]);

    return (
        <div className={styles.main}>
            <div className={styles.header}>
                <div className={styles.headerRight}>دستگاه ها</div>
                <div className={styles.headerLeft} onClick={() => history("/map")}>
                    <KeyboardArrowLeftIcon className={styles.exitIcon} />
                    بازگشت
                </div>
            </div>
            <div className={styles.body}>
                <div className={styles.bodyTop}>
                    <div className={styles.bodyTopText}>تعداد کل دستگاه ها :{devices.length}</div>

                    <div className={styles.search_holder}>
                        <Button className={styles.add} variant="contained" component="label" onClick={() => history("/management/devices/edit/new")}>
                            افزودن دستگاه
                        </Button>
                        <span className={styles.GlobalFilterHolder}>
                            <input className={styles.GlobalFilter} value={search} onChange={(e) => set_search(e.target.value)} />

                            <FcSearch size={20} />
                        </span>
                    </div>
                </div>
                <div className={styles.contents}>
                    <div style={{ width: "100%", height: "100%", minWidth: 856 }}>
                        <AutoSizer>
                            {({ height, width }) => (
                                <Table
                                    rowClassName={({ index: i }) => (i % 2 === 0 ? "table_ch_env" : "----")}
                                    rowCount={devices.length}
                                    rowGetter={({ index }) => devices[index]}
                                    width={width}
                                    height={height}
                                    headerHeight={20}
                                    rowHeight={50}
                                    onRowClick={({ rowData }) => history(`/management/devices/edit/${rowData.id}`)}
                                >
                                    <Column
                                        dataKey={"0"}
                                        flexGrow={1}
                                        width={140}
                                        minWidth={140}
                                        maxWidth={140}
                                        label="نام"
                                        height={50}
                                        cellRenderer={({ rowIndex, rowData }) => rowData.name}
                                    />
                                    <Column
                                        dataKey={"0"}
                                        flexGrow={1}
                                        width={140}
                                        minWidth={140}
                                        maxWidth={140}
                                        label="ID دستگاه"
                                        height={50}
                                        cellRenderer={({ rowIndex, rowData }) => rowData.uniqueId}
                                    />
                                    <Column
                                        dataKey={"0"}
                                        flexGrow={1}
                                        width={140}
                                        minWidth={140}
                                        maxWidth={140}
                                        label="شماره دستگاه"
                                        height={50}
                                        cellRenderer={({ rowIndex, rowData }) => (rowData.phone === "" ? "----" : rowData.phone)}
                                    />
                                    <Column
                                        dataKey={"0"}
                                        flexGrow={1}
                                        label="تاریخ فعال سازی"
                                        height={50}
                                        cellRenderer={({ rowIndex, rowData }) =>
                                            rowData.attributes.createtionDate ? new JDate(new Date(rowData.attributes.createtionDate)).format("dddd DD MMMM YYYY") : "----"
                                        }
                                        width={140}
                                        minWidth={140}
                                        maxWidth={140}
                                    />
                                    <Column
                                        dataKey={"0"}
                                        flexGrow={1}
                                        label="آخرین فعالیت"
                                        height={50}
                                        width={140}
                                        minWidth={140}
                                        maxWidth={140}
                                        cellRenderer={({ rowIndex, rowData }) => (rowData.lastUpdate ? new JDate(new Date(rowData.lastUpdate)).format("dddd DD MMMM YYYY") : "----")}
                                    />
                                    <Column
                                        dataKey={"0"}
                                        label="پایان اشتراک"
                                        height={50}
                                        cellRenderer={({ rowIndex, rowData }) =>
                                            rowData.attributes.subscriptionEndDate ? new JDate(new Date(rowData.attributes.subscriptionEndDate)).format("dddd DD MMMM YYYY") : "----"
                                        }
                                        flexGrow={1}
                                        width={140}
                                        minWidth={140}
                                        maxWidth={140}
                                    />
                                </Table>
                            )}
                        </AutoSizer>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Devices;
